import { people } from "@/mocks/site";

export default function People() {
  return (
    <section id="people" className="w-full bg-background-50 py-16 md:py-24">
      <div className="px-4 md:px-8 max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-4">
          <div className="max-w-3xl">
            <span className="text-sm font-medium text-primary-600 tracking-widest uppercase">
              People
            </span>
            <h2 className="mt-3 font-heading text-2xl md:text-4xl font-bold text-foreground-950">
              那些把类型推向高度的名字
            </h2>
            <p className="mt-4 text-foreground-700 text-sm md:text-base leading-relaxed">
              一个好故事要被讲得可信，靠的是导演与演员的共同塑造。以下几位创作者，
              是理解这一类型时绕不开的名字。
            </p>
          </div>
          <p className="text-xs text-foreground-500 max-w-xs">注：人物配图为版式示意插画，非本人照片。</p>
        </div>

        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {people.map((person) => (
            <article
              key={person.name}
              className="rounded-lg overflow-hidden bg-background-100 border border-background-200 flex flex-col sm:flex-row lg:flex-col"
            >
              <div className="w-full sm:w-32 sm:shrink-0 lg:w-full h-48 sm:h-auto lg:h-56 overflow-hidden">
                <img
                  src={person.photo}
                  alt={`${person.name} 人物示意插画`}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="p-4 md:p-5 flex-1">
                <h3 className="font-heading text-lg md:text-xl font-bold text-foreground-950">
                  {person.name}
                </h3>
                <p className="mt-1 text-xs md:text-sm text-accent-700">{person.role}</p>
                <p className="mt-3 text-sm text-foreground-600 leading-relaxed">{person.text}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}